import { BrowserRouter as BaseRouter, Switch, Route } from 'react-router-dom';
import App from './App'
import React from 'react'
import { contentPath, modules } from './config/pages'
import ViewWrapper from './pages/ViewWrapper'
import Forbidden from './pages/Forbidden'
import HomePage from './pages/home/HomePage'
import CalendarPage from './pages/calendar/CalendarPage'
import ViewCalendarPage from './pages/calendar/ViewCalendarPage'
import TrackingPage from './pages/tracking/TrackingPage'
import ConsultEventsPage from './pages/tracking/event/detail/ConsultEventsPage'
import ContactPage from './pages/contacts/ContactPage'

const Router = BaseRouter as any;

const Error404 = () => <div>404 Not Found</div>

function Routes(){
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={App}/> 
        <Route exact path={contentPath[modules.Forbidden]} component={Forbidden}/> 
        
        <Route exact path={contentPath[modules.Home]}>
            <ViewWrapper component={HomePage} module={modules.Home} />
        </Route>
        
        {/* Calendar Routes */}
        <Route exact path={contentPath[modules.Calendar]}>
            <ViewWrapper component={CalendarPage} module={modules.Calendar} />
        </Route>
        <Route exact path={`${contentPath[modules.Calendar]}/:view/:year/:month/:day`}>
            <ViewWrapper component={ViewCalendarPage} module={modules.Calendar} />
        </Route>

        {/* Tracking Routes */}
        <Route exact path={contentPath[modules.Tracking]}>
            <ViewWrapper component={TrackingPage} module={modules.Tracking} />
        </Route>
        <Route exact path={`${contentPath[modules.Tracking]}/event/:year/:month/:day`}>
            <ViewWrapper component={ConsultEventsPage} module={modules.Tracking} />
        </Route>

        {/* Contact Routes */}
        <Route exact path={contentPath[modules.Contacts]}>
            <ViewWrapper component={ContactPage} module={modules.Contacts} />
        </Route>

        <Route component={Error404} />
      </Switch>
    </Router>
  )
}

export default Routes

